export default {
  profile: 'プロフィール',
  settings: '設定',
  createContentTip: '新規作成時、このコンテンツは {label} に属します。{label} で入力してください。',
  createContentExample: '例：新製品を作成する場合、製品名、説明などのフィールドは',
  langLevel: 'ベース: {label}',
};
